import dynamic from 'next/dynamic';
import { QuickGroupConfirmationProps } from './QuickGroupConfirmation.types';

export const QuickGroupConfirmation = dynamic<{ model: QuickGroupConfirmationProps }>(() =>
  import('./QuickGroupConfirmation').then(mod => mod.QuickGroupConfirmation)
);
